module.exports = "/static/media/star.d585c01f.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/icons/star.svg
// module id = 1473
// module chunks = 0